/**
 * 创建人：但志强
 * 时间：2019-3-29
 * 描述：加载过度效果
 * 使用说明: 参考 sw-loadingmask 配置应用说明文档
 * 更新记录: 
 */
import { Component, OnInit, Input } from '@angular/core';
declare var $: any;
@Component({
  selector: 'sw-loadingmask',
  templateUrl: './sw-loadingmask.component.html',
  styleUrls: ['./sw-loadingmask.component.css']
})
export class SwLoadingmaskComponent implements OnInit {

  @Input() ids:string
  constructor() { }


  //打开加载页面
  openLoading() {
    // $("#maskModal").addClass('in')
    // $("#maskModal").css({'display':"block"})
    $("#maskModal").modal("show");
    /* setTimeout(() => {
      this.closeLoading()
    }, 8000); */
  }
  //关闭加载页面
  closeLoading() {
    if($("#maskModal")){
      $("#maskModal").modal("hide");

    }
  }

  ngOnInit(): void {
  }
}
